import { createFileRoute } from '@tanstack/react-router'
import { RialAdjustmentsPage } from '@/features/rial-adjustments'

export const Route = createFileRoute('/_authenticated/rial-adjustments/')({
  component: RialAdjustmentsPage,
})
